<template>
  <div class="country-pulse">
    <div
      v-if="isLoadingBlocks || newsFeedStore.loading"
      class="country-pulse__loader"
    >
      <LocalLoader />
      {{ t('pulse_page.loader') }}
    </div>

    <template v-else>
      <div
        v-if="topics && topics.length > 0 && !isLoadingBlocks && !newsFeedStore.loading"
        class="country-pulse__topic-rows row"
      >
        <PulseTopicCard
          v-for="topic in topics"
          :key="topic.id"
          :topic="topic"
        />
      </div>

      <div
        v-else
        class="country-pulse__empty"
      >
        <div class="country-pulse__empty-container">
          <span class="country-pulse__empty-title">
            {{ t('country_pulse_topic_card.topic_empty_title') }}
          </span>
          <span class="country-pulse__empty-text">
            {{ t('country_pulse_topic_card.topic_empty_text') }}
          </span>
        </div>
      </div>
    </template>
  </div>
</template>


<script setup>
import { useLK } from "@/controllerLK/LKstore.js";
import { onBeforeUnmount, onMounted, ref, watch } from "vue";
import PulseTopicCard from "@/components/PulsePage/PulseTopicCard.vue";
import { t } from "@/controllerLK/AvalLocalization";
import LocalLoader from "@/components/UI/LocalLoader.vue";
import { useNewsFeedStore } from "@/store/NewsFeed/newsFeed";
import { useRubricsStore } from "@/store/NewsFeed/rubrics";
import { useThemesStore } from "@/store/NewsFeed/themes";
import { useNotificationsStore } from "@/store/notifications";

const LKStore = useLK();
const newsFeedStore = useNewsFeedStore();
const themesStore = useThemesStore();
const rubricsStore = useRubricsStore();
const notificationStore = useNotificationsStore();

// Флаг загрузки карточек
const isLoadingBlocks = ref(false);

// Список всех карточек тем пульса
const topics = ref([]);

// Храним ID интервала
const intervalId = ref(null);

// Установка интервала загрузки карточек пульса
const startLoadingData = async () => {
  await getTopics();
  intervalId.value = setInterval(async () => {
    await getTopics();
  }, 300000);
};

// Запрос загрузки карточек пульса
const getTopics = async () => {
  try {
    isLoadingBlocks.value = true;
    topics.value = await themesStore.getAllThemesPulse();
  } catch (err) {
    console.error(err);
  } finally {
    isLoadingBlocks.value = false;
  }
};

// Очистка интервала загрузки карточек тем пульса.
const stopLoadingData = () => {
  if (intervalId.value !== null) {
    clearInterval(intervalId.value);
    intervalId.value = null;
  }
};

// Вотчер на активный проект
watch(
  () => LKStore.project?.id,
  async () => {
    await startLoadingData();
  }
);

onMounted(async() => {
  await startLoadingData();
  await rubricsStore.getAllRubrics();
  if (!rubricsStore.rubricsOnMonitoring.length) {
    window.routerLK.push("/");
    notificationStore.createNotify(t("notification_item.error.no_rubric"), "error");
  }
});

onBeforeUnmount(() => {
  stopLoadingData();
});
</script>

<style lang="scss" scoped>
.country-pulse {
  &__topic {
    font-family: "Roboto", serif;
    font-size: 14px;

    &-rows {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr 1fr;
      grid-gap: 20px;
    }
  }

  &__empty {
    height: calc(100vh - 100px);
    width: 100%;

    &-container {
      width: 100%;
      height: 100%;
      background: var(--background-bg-white);
      border-radius: 10px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      text-align: center;
    }

    &-title {
      font-size: 16px;
      line-height: 22px;
      font-weight: 500;
    }

    &-text {
      color: var(--text-text-main);
      font-size: 14px;
      line-height: 20px;
      margin-top: 20px;
      max-width: 208px;
    }
  }

  &__loader {
    display: flex;
    flex-direction: column;
    gap: 30px;
    z-index: 9999;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 16px;
    font-weight: 500;
    color: var(--text-text-main);
    align-items: center;
  }
}
</style>

